export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SAVE_TOKEN = 'USER_LOGIN_SAVE_TOKEN';
export const USER_LOGOUT = 'USER_LOGOUT';

export interface LoginToken {
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
}

// Action to log-in without persisting tokens
export const login = (expiresAt: string) => {
  return {
    payload: expiresAt,
    type: USER_LOGIN,
  };
};

// Action to log-in and persist tokens
export const loginAndSaveToken = (loginToken: LoginToken) => {
  return {
    payload: loginToken,
    type: USER_LOGIN_SAVE_TOKEN,
  };
};

export const logout = () => {
  return {
    type: USER_LOGOUT,
  };
};
